precision highp float;

uniform float time;
uniform float size;
uniform float pixelRatio;
uniform float uMobile;

attribute float aRandom;
attribute float aAlpha;

varying float vAlpha;
varying float vRandom;
varying vec3 vWorldPos;

void main() {
  vec3 pos = position;
  float r = aRandom;
  float t = time * 0.6;

  float mobile = clamp(uMobile, 0.0, 1.0);

  float swayAmp = mix(0.05, 0.015, mobile);
  float swirlAmp = mix(0.02, 0.004, mobile);
  float swirlFreq = mix(1.0, 0.4, mobile);

  float swayY = sin(t + r * 6.2831853) * swayAmp;

  float swirl = sin(
    (t * 0.35 * swirlFreq) +
    pos.y * 0.8 +
    r * 10.0
  ) * swirlAmp;

  vec3 animated = pos + vec3(
    sin(pos.x * 1.5 + t + r * 5.0) * 0.02,
    swayY + swirl,
    cos(pos.z * 1.2 + t * 0.4 + r) * 0.02
  );

  vec4 mvPosition = modelViewMatrix * vec4(animated, 1.0);

  float depth = max(-mvPosition.z, 0.0001);
  float psize = size * (1.0 + r * 0.8) * (pixelRatio / depth);
  psize = clamp(psize, 4.0, 200.0);

  gl_PointSize = psize;
  gl_Position = projectionMatrix * mvPosition;

  vAlpha = (0.25 + 0.75 * r) * aAlpha;
  vRandom = r;
  vWorldPos = (modelMatrix * vec4(animated, 1.0)).xyz;
}